(() => {
  const guarantee = document.getElementById('cb-guarantee');
  let opener;
  document.addEventListener('click', e => {
    const trigger = e.target.closest('[data-cb-guarantee]');
    if (trigger && guarantee) { opener = trigger; guarantee.showModal(); }
    if (e.target.closest('[data-cb-guarantee-close]')) guarantee?.close();
    const menu = document.querySelector('.cb-menu');
    if (menu?.open && !menu.contains(e.target)) menu.open = false;
  });
  guarantee?.addEventListener('close', () => opener?.focus());
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') document.querySelectorAll('.cb-menu[open]').forEach(x => { x.open = false; x.querySelector('summary').focus(); });
  });
  // Wrap legacy imported tables without altering their data.
  document.querySelectorAll('.rte table').forEach(table => {
    if (table.parentElement.style.overflowX === 'auto' || table.parentElement.classList.contains('cb-table-scroll')) return;
    const wrap = document.createElement('div'); wrap.className = 'cb-table-scroll'; wrap.tabIndex = 0;
    wrap.setAttribute('role', 'region'); wrap.setAttribute('aria-label', 'Tabelle, horizontal scrollbar');
    table.before(wrap); wrap.append(table);
  });
})();
